/**
 * Which operations confirm before they go (DESIGN §3.1: "destructive or paid
 * account drops confirm first"), read from the spec: an operation's class,
 * tags, path and security, never its name, so a new one is judged the same
 * way. The one table: the Deck, the Account screen, the hand's launch verbs
 * and Actions all ask it, so a drop and a click on the same card show the
 * same sheet. Pure.
 */

import type { Args, Operation } from '../contracts';

export type ConfirmKind = 'destructive' | 'money' | 'server';

export const confirmOf = (op: Operation | undefined, args: Args): ConfirmKind | null => {
  if (!op) return null;
  if (op.security === 'stripe') return 'server';
  if (op.cls === 'delete') return 'destructive';
  if (/:rotate$/.test(op.path)) return 'destructive';
  if (op.tags.includes('billing') && op.method === 'POST') {
    // A mock act that ends or fails the subscription undoes something; the others only play one out.
    if (op.path.includes('/mock/')) return args.act === 'cancel' || args.act === 'fail' ? 'destructive' : null;
    return 'money';
  }
  if ((op.tags.includes('grants') || op.tags.includes('webhooks')) && op.method === 'POST') return 'destructive';
  return null;
};
